import { useMemo } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import ReviewsTable from "src/components/pages/Summary/ReviewsTable/ReviewsTable";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { useGetApi } from "src/hooks";
import { PageContainer } from "src/styled";

import { mapSummary } from "../Summary/Summary.utils";

const Exports = () => {
  const { search, pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const { data, isLoading } = useGetApi({
    request: "get-exports",
    body: {
      params: {
        code: searchParams.get("code"),
        email: searchParams.get("email"),
        access: searchParams.get("access"),
        ...(searchParams.get("sort") && searchParams.get("dir")
          ? {
              sort: searchParams.get("sort"),
              dir: searchParams.get("dir"),
            }
          : {}),
      },
      code: searchParams.get("code"),
      email: searchParams.get("email"),
      access: searchParams.get("access"),
    },
    mapper: mapSummary,
  });

  const links = useMemo(
    () => [{ title: "Medical Log Entries", href: pathname + search }],
    [pathname, search],
  );

  return (
    <PageContainer>
      <Breadcrumbs border={false} customLinks={links} />
      <ReviewsTable
        reviews={data?.reviews ?? []}
        loading={isLoading}
        readonlyComments
      />
    </PageContainer>
  );
};

export default Exports;
